import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import DocumentStore from 'notebook/documents/DocumentStore';
import EntryStore from 'stores/EntryStore';
import APIUtil from 'util/APIUtil';
import StageEntryStore from 'workflows/stage-entries/StageEntryStore';

/**
 * Returns `true` if the given document like item is in a store.
 *
 * @param documentLikeId - an API identifier for an Entry, Document, or a StageEntry
 */
export default function isInStore(documentLikeId: string): boolean {
  const itemType = APIUtil.apiIdToType(documentLikeId);
  if (itemType === ModelTypeConstants.STAGE_ENTRY) {
    return StageEntryStore.inStore(documentLikeId);
  } else if (itemType === ModelTypeConstants.DOCUMENT) {
    return DocumentStore.inStore(documentLikeId);
  } else {
    assert(itemType === ModelTypeConstants.ENTRY, 'Unexpected document type', {documentLikeId});
    return EntryStore.inStore(documentLikeId);
  }
}
